<fgb-page-header [pageTitle]="'trivia.banner.text'" [backButtonLink]="'/games'" [showFooter]="false"></fgb-page-header>

<div class="game-details-banner bg-primary w-100">
  <div class="container">
    <a class="text-white fw-bold d-flex flex-row align-items-center" [routerLink]="'/games'"
      ><span class="pe-2 material-icons fw-bold">keyboard_arrow_left</span>{{ 'games.back.btn' | translate }}</a
    >

    <img [src]="'banners/games/trivia-banner.png' | contentAssetImage" alt="Game details banner" />
  </div>
</div>

<fgb-leaderboard-nav routeLink="trivia"></fgb-leaderboard-nav>
<router-outlet></router-outlet>
